export const PATH = {
  AGENT_SEARCH: '/agent-search',
  ARREARS_PAYMENT: '/arrears-payment',
  CLAIMS: '/claims',
  DASHBOARD: '/dashboard',
  DOCUMENTS: '/documents',
  LOGIN: '/login',
  MAKE_CHANGES: '/make-changes',
  PAYMENT_MANAGEMENT_WEBCHAT: '/payment-management',
  PAYMENT_MANAGEMENT: '/customer-payment-management',
  QUOTES: '/quotes',
  RENEWAL: '/renewal',
  SETTINGS: '/settings',
  AUDIT: '/audit',
  NOTES: '/notes'
} as const;

export type Path = (typeof PATH)[keyof typeof PATH];

export const EXTERNAL_PATH = {
  CONTACT_US: 'https://www.homeprotect.co.uk/contact-us',
  FAQS: 'https://www.homeprotect.co.uk/faqs'
} as const;

export type ExternalPath = (typeof EXTERNAL_PATH)[keyof typeof EXTERNAL_PATH];

export type AllPaths = Path | ExternalPath;

export const LOGIN_PATH = {
  DEFAULT: '/',
  CLAIMS: '/claims',
  QUOTES: '/quotes'
} as const;

export type LoginPath = (typeof LOGIN_PATH)[keyof typeof LOGIN_PATH];
